import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useAvailablePermissions, useCreateApiKey } from '../../../hooks';

export default function CreateApiKeyModal({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const { data: permissionsData } = useAvailablePermissions();
  const createApiKey = useCreateApiKey();

  const permissions = permissionsData?.permissions || [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await createApiKey.mutateAsync({
      name,
      permissions: selectedPermissions,
    });
    onCreated(result);
  };

  const togglePermission = (perm) => {
    setSelectedPermissions((prev) =>
      prev.includes(perm) ? prev.filter((p) => p !== perm) : [...prev, perm]
    );
  };

  return (
    <div className="workbench-modal-overlay" onClick={onClose}>
      <div className="workbench-modal" onClick={(e) => e.stopPropagation()}>
        <div className="workbench-modal-header">
          <h2>Create API Key</h2>
          <button className="workbench-modal-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="workbench-modal-body">
            <div className="form-group">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="workbench-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g., Production API Key"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Permissions</label>
              <div className="permissions-grid">
                {permissions.map((perm) => (
                  <label
                    key={perm}
                    className={`permission-checkbox ${selectedPermissions.includes(perm) ? 'selected' : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedPermissions.includes(perm)}
                      onChange={() => togglePermission(perm)}
                    />
                    <span className="permission-label">{perm}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="workbench-modal-footer">
            <button type="button" className="workbench-btn workbench-btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="workbench-btn workbench-btn-primary"
              disabled={!name || createApiKey.isPending}
            >
              {createApiKey.isPending ? 'Creating...' : 'Create Key'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
